export * from '@fhs/routing/src/routes/v2/offers/details/[offerId]';
export { default } from '@fhs/routing/src/routes/v2/offers/details/[offerId]';
